import { Address, CompanyAddress, Customer } from 'src/shared/api';
import {
	CustomerDetails,
	CustomerDetailGeneralInformation,
} from './customer-detail.models';

export function customerFormToCustomer(formValue: CustomerDetails): Customer {
	let customer: Customer;
	if (formValue) {
		const {
			documents,
			contractedRates,
			contacts,
			companyAddresses = [],
			...details
		} = formValue;

		customer = {
			documents,
			contractedRates,
			contacts,
			companyAddresses,
			...details.generalInfo,
		};
	}
	return customer;
}

export function customerToCustomerForm(
	customer: Customer
): CustomerDetails | null {
	if (customer) {
		return {
			generalInfo: customerToGeneralInfo(customer),
			companyAddresses: customer.companyAddresses || [],
			contractedRates: customer.contractedRates,
			documents: customer.documents || [],
			contacts: customer.contacts || [],
		};
	} else {
		return {
			generalInfo: null,
			companyAddresses: [],
			documents: [],
			contacts: [],
			contractedRates: null,
		};
	}
}

function customerToGeneralInfo(
	customer: Customer
): CustomerDetailGeneralInformation {
	return {
		id: customer.id,
		companyName: customer.companyName,
		employerIdentificationNumber: customer.employerIdentificationNumber,
		billingEmail: customer.billingEmail,
		flairDocsCustomerId: customer.flairDocsCustomerId,
	};
}

export function getDefaultAddress(addresses: CompanyAddress[] | undefined): Address | undefined {
	return addresses?.find((a) => a.isDefault)?.address;
}
